import { render } from "./AccountTravellers.vue?vue&type=template&id=0be3cae9&scoped=true"
import script from "./AccountTravellers.vue?vue&type=script&lang=js"
export * from "./AccountTravellers.vue?vue&type=script&lang=js"

import "./AccountTravellers.vue?vue&type=style&index=0&id=0be3cae9&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0be3cae9"]])

export default __exports__